import { createFileRoute, Navigate } from "@tanstack/react-router";
import { McpAccessPage } from "@/pages/mcp-access";
import { useCanUseMcp } from "@/entities/company/hooks/use-can-use-mcp";

const McpRoute = () => {
  const canUseMcp = useCanUseMcp();

  if (!canUseMcp) {
    return <Navigate to="/" replace />;
  }

  return <McpAccessPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/mcp",
)({
  component: McpRoute,
});
